const currentDate = new Date()
let after30DaysDate = new Date()
after30DaysDate.setDate(after30DaysDate.getDate() + 30)
const sales_receipts = {
  permissionSource: 'api::sales-receipt.sales-receipt',
  creationTitle: 'Create Sales Receipt',
  creationEndPoint: '/sales-receipts',
  listingTitle: 'Sales Receipts',
  listingEndPoint: '/sales-receipts?populate[0]=client&populate[1]=sales_invoice',
  listingCollectibleRoute: '/sales-receipts/:id',
  listing: [
    { title: 'Code', value: 'code', class: 'text-center' },
    { title: 'Client', value: 'client.data.attributes.name', class: '' },
    { title: 'Sales Invoice', value: 'sales_invoice.data.attributes.code', class: '' },
  ],
  detailTitle: 'Sales Receipt: :code',
  detailEndPoint:
    '/sales-receipts/:id?populate[0]=business_entity&populate[1]=document_type&populate[2]=client.whatsapp&populate[3]=staff&populate[4]=contact_person.whatsapp&populate[5]=term_and_condition&populate[6]=receipt_items.product&populate[7]=e_sign&populate[8]=signed_document&populate[9]=variables.variable&populate[10]=sales_invoice&populate[11]=receipt_items.product_image',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Code',
              value: 'code',
              tag: 'input',
              type: 'text',
              placeholder: 'Sales Receipt Code',
              required: true,
            },
            {
              label: 'Document Type',
              value: 'document_type',
              tag: 'single-select',
              dataSourceUrl: '/document-types',
              dataLabel: 'title',
            },
            {
              label: 'Create Date',
              value: 'create_date',
              tag: 'date-picker',
              required: true,
            },
            {
              label: 'Transaction Date',
              value: 'transaction_date',
              tag: 'date-picker',
            },
            {
              label: 'Client',
              value: 'client',
              tag: 'single-select',
              dataSourceUrl: '/clients',
              dataLabel: 'name',
              required: true,
            },
            {
              label: "Contact Person (Client's side)",
              value: 'contact_person',
              tag: 'single-select',
              dataSourceUrl: '/contact-people',
              dataLabel: 'name',
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Business Entity',
              value: 'business_entity',
              tag: 'single-select',
              dataSourceUrl: '/business-entities',
              dataLabel: 'title',
              required: true,
            },
            {
              label: 'Version',
              value: 'version',
              tag: 'static-text',
              type: 'number',
              placeholder: 'Sales Receipt Version',
            },
            {
              label: 'Expiry Date',
              value: 'expiry_date',
              tag: 'date-picker',
            },
            {
              label: 'Staff (Our side)',
              value: 'staff',
              tag: 'single-select',
              dataSourceUrl: '/staffs',
              dataLabel: 'name',
              required: true,
            },
            {
              label: 'E-Sign',
              value: 'e_sign',
              tag: 'single-select',
              dataSourceUrl: '/e-signs',
              dataLabel: 'description',
            },
            {
              label: 'Terms and Conditions',
              value: 'term_and_condition',
              tag: 'single-select',
              dataSourceUrl: '/terms-and-conditions',
              dataLabel: '[code] - [title] - [description]',
            },
          ],
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Project Title',
              value: 'sales_project_title',
              tag: 'input',
              type: 'text',
              placeholder: 'Project Title',
            },
            {
              label: 'Project Date',
              value: 'sales_project_date',
              tag: 'date-picker',
            },
            {
              label: 'Shipping Label',
              value: 'shipping_label',
              tag: 'input',
              type: 'text',
              placeholder: 'Shipping Label',
            },
            {
              label: 'Payment Description',
              value: 'payment_description',
              tag: 'input',
              type: 'text',
              placeholder: 'Payment Description',
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Project Description',
              value: 'sales_project_description',
              tag: 'input',
              type: 'text',
              placeholder: 'Project Description',
            },
            {
              label: 'Project Venue',
              value: 'sales_project_venue',
              tag: 'input',
              type: 'text',
              placeholder: 'Project Venue',
            },
            {
              label: 'Shipping Charge',
              value: 'shipping_charge',
              tag: 'input',
              type: 'text',
              placeholder: 'Shipping Charge',
            },
          ],
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Minimum Display Row Number',
              value: 'minimum_display_item_no',
              tag: 'input',
              type: 'number',
              placeholder: 'Default row number: [minimum_display_template_row_number]',
            },
          ],
        },
      ],
    },
    {
      label: 'Remark',
      value: 'remark',
      tag: 'richTextarea',
    },
    {
      label: 'Sales Invoice',
      value: 'sales_invoice',
      tag: 'single-select',
      dataSourceUrl: '/sales-invoices',
      dataLabel: 'code',
      required: true,
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
    create_date: currentDate,
    expiry_date: after30DaysDate,
  },
}
export default sales_receipts
